import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { Shield, Lock, Mail, ArrowRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);

  React.useEffect(() => {
    if (!loading && user) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const r = await login(email, password);
    setSubmitting(false);
    if (r.ok) {
      toast.success("Welcome back, admin.");
      navigate("/admin");
    } else {
      setError(r.error);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-20" data-testid="admin-login-page">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top,rgba(14,165,233,0.18),transparent_55%)]" />
      <div className="w-full max-w-md mfb-container">
        <div className="card-luxury p-8 sm:p-10">
          <div className="flex items-center justify-center w-12 h-12 rounded-xl border border-[#D4AF37]/40 bg-[#D4AF37]/10 mb-6">
            <Shield className="w-5 h-5 text-[#D4AF37]" />
          </div>
          <h1 className="font-[Outfit] text-3xl text-white font-light">Admin Login</h1>
          <p className="text-slate-400 text-sm mt-2">Restricted area. Authorized personnel only.</p>

          <form onSubmit={onSubmit} className="mt-8 space-y-5">
            <div>
              <label className="text-xs uppercase tracking-widest text-slate-400 mb-2 flex items-center gap-1.5">
                <Mail className="w-3.5 h-3.5" /> Email
              </label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="admin-email-input"
                placeholder="admin@myfundingbank.com"
                className="bg-[#111827] border-white/10 text-white placeholder:text-slate-500 focus:border-sky-500"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-slate-400 mb-2 flex items-center gap-1.5">
                <Lock className="w-3.5 h-3.5" /> Password
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="admin-password-input"
                className="bg-[#111827] border-white/10 text-white placeholder:text-slate-500 focus:border-sky-500"
              />
            </div>
            {error && (
              <div className="text-rose-400 text-xs" data-testid="admin-login-error">
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={submitting}
              data-testid="admin-login-submit"
              className="btn-primary w-full"
            >
              {submitting ? "Signing in…" : "Sign in"} <ArrowRight className="w-4 h-4" />
            </button>
          </form>

          <div className="mt-6 text-xs text-slate-500 text-center">
            <Link to="/" className="hover:text-white">← Back to site</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
